import VisualBackgroundControl from '@office-start/visual-background-control';
import { useVisualBackgroundImage } from '@office-start/visual-service';
import React from 'react';
export var VisualBackgroundComponent = function (_a) {
    var widthRestrictorOffset = _a.widthRestrictorOffset;
    var props = useVisualBackgroundImage();
    if (!props) {
        return null;
    }
    return (React.createElement(VisualBackgroundControl, { backgroundImageURL: props.backgroundImageURL, backgroundGradient: props.backgroundGradient, isHomePage: props.isHomePage, isOpacity32: props.isOpacity32, themeId: props.themeId, visualBackgroundGradientEnabled: props.visualBackgroundGradientEnabled, telemetryCallbacks: props.telemetryCallbacks, widthRestrictorOffset: widthRestrictorOffset }));
};
//# sourceMappingURL=VisualBackgroundComponent.js.map